// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"7081412e","90":"566a1b7a","279":"605ccd1d","379":"45772bf8","425":"49a44786","841":"caaf2f7e","900":"ce8c3601","906":"1bb2539c","938":"35ec9c38"}[chunkId] + ".chunk.js";
};